import {MutationTree} from "vuex";
import {FormModalState} from "../types/FormModalState";
import Vue from 'vue';
import {EventBus} from "@common/EventBus";

export const mutations: MutationTree<FormModalState> = {
    setElements(state, elements) {
      Vue.set(state, 'elements', elements);
    },
    addElement(state, element) {
        if (!('isLive' in element)) {
            element['isLive'] = false;
        }
        state.elements.push(element);
    },
    updateElement(state, {index, element}) {
        Vue.set(state.elements, index, element);
    },
    deleteElement(state, index) {
        state.elements.splice(index, 1);
    },
    seIsLive(state, {index, isLive}) {
        Vue.set(state.elements[index], 'isLive', isLive);
    },
    minimize(state, ids: string[]) {
        ids.forEach(id => {
            const index = state.elements.findIndex(item => item.id == id);
            Vue.set(state.elements[index], 'state',  'minimized');
        })
    },
    fullScreen(state, ids: string[]) {
        ids.forEach(id => {
            const index = state.elements.findIndex(item => item.id == id);
            Vue.set(state.elements[index], 'state',  'maximized');
        })
    },
    normalize(state, ids: string[]) {
        ids.forEach(id => {
            const index = state.elements.findIndex(item => item.id == id);
            Vue.set(state.elements[index], 'state',  'full');
        })
    },
    setState(state, {ids, newState}: {ids: string[]; newState: string}) {
        ids.forEach(id => {
            const index = state.elements.findIndex(item => item.id == id);
            Vue.set(state.elements[index], 'state',  newState);
        })
    }
}
